<template>
    <div class="px-4 absolute left-0 -top-9 w-full text-white">
        <div class="quick-menu-container flex items-center">
            <!-- <div class="flex-auto text-center" @click="goToHistory()">
                <div class="mb-1">
                    <img src="@/assets/icon/misc/history.svg" class="mx-auto" alt />
                </div>
                <span class="text-sm" v-text="lbl.profile.quickMenu.history"></span>
            </div>
            <div
                class="flex-none bg-white bg-opacity-20 h-auto"
                :style="{ width: '1px', height: '40px' }"
            >&nbsp;</div> -->
            <div class="flex-auto text-center" @click="goToApplyCard()">
                <div class="mb-1">
                    <img src="@/assets/icon/misc/card-plus.svg" class="mx-auto" alt />
                </div>
                <span class="text-sm" v-text="lbl.profile.quickMenu.applyCard"></span>
            </div>
        </div>
    </div>
</template>
<script>
import LocaleMixin from "@/mixin/LocaleMixin"

export default {
    name: 'ProfileQuickMenu',
    props: {},
    components: {},
    mixins: [LocaleMixin],
    emits: [],
    data: function () { return {} },
    computed: {},
    created: function () { },
    mounted: function () { },
    methods: {
        goToHistory: function(){
            this.tracking.event('redeem_history', 'click_redeem_history', null, null);
            this.$router.push({
                name: "history"
            })
        },
        goToApplyCard: function(){
            this.tracking.event('apply_card', 'click_apply_card', null, null);
            this.$router.push({
                name: "apply-card"
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.quick-menu-container {
    height: 72px;
    border-radius: 15px;
    box-shadow: 0 0 10px 0 rgba(23, 55, 127, 0.31);
    background-image: linear-gradient(90deg, #0054af, #008eed);
    // background-image: url("~@/assets/img/bg/bg-profile-quick-menu.svg");
    // background-size: 100% 100%;
}
</style>
